jQuery(document).ready(function ($) {

    // Assign handlers immediately after making the request,
    // and remember the jqxhr object for this request
    let $postalCode;
    let $houseNumber;

    $(document).on('change', '.sac-postal input, .sac-number input', function () {
        let postalField = $('.sac-postal input');
        let noField = $('.sac-number input');
        let $el = $(this);
        let $form = $el.closest('form');

        $postalCode = postalField.val().replace(" ", "");
        $houseNumber = noField.val().replace(" ", "");

        if (postalField.val() !== '' && noField.val() !== '') {
            let data = {
                'action': 'postcode_complete_v2',
                'postalcode': $postalCode,
                'housenumber': $houseNumber
            };

            $form.addClass('sac-loading');

            let ajaxUrl = window.location.href.includes('.dev') ? '/wp/wp-admin/admin-ajax.php' : '/wp-admin/admin-ajax.php';

            $.post(ajaxUrl, data)
                .done(function (response) {
                    let parsedResponse = JSON.parse(response);

                    if (!parsedResponse['error']) {

                        $('.sac-street input').val(parsedResponse['street']);
                        $('.sac-city input').val(parsedResponse['city']);

                        // Add check
                        if (parsedResponse['street'] && parsedResponse['city']) {
                            $('.sac-street input').parent().addClass('checked-green non-editable');
                            $('.sac-city input').parent().addClass('checked-green non-editable');
                            // Enable readonly
                            $('.sac-street input').attr('readonly', true);
                            $('.sac-city input').attr('readonly', true);
                        }

                    } else {
                        // Make sure inputs are not checked if there is no response
                        $('.sac-street input').parent().removeClass('checked-green non-editable');
                        $('.sac-city input').parent().removeClass('checked-green non-editable');
                        // Disable readonly
                        $('.sac-street input').attr('readonly', false);
                        $('.sac-city input').attr('readonly', false);
                    }
                })
                .always(function () {
                    $form.removeClass('sac-loading');
                    $('.sac-street, .sac-city').removeClass('sac-hidden');
                });
        }
    });
});
